export default {
  // baseURL: 'http://178.62.46.109:81/'
  // baseURL: 'https://api-demo.websanova.com/api/v1'
  baseURL: process.env.VUE_APP_API_URL,
  clientId: process.env.VUE_APP_CLIENT_ID,
  clientSecret: process.env.VUE_APP_CLIENT_SECRET
};
